define('lib/LoadWithNonce',['require','jquery'],function (require) {

    var $ = require('jquery');

    /**
     * jQuery 1.11.3's own script-execution machinery (used internally by .load()/.html()/.append())
     * always recreates <script> elements from scratch - for ones with a src, via a synchronous
     * re-fetch (jQuery._evalUrl) - and never copies non-standard attributes like `nonce` onto the
     * element it actually runs. So a server-injected CSP nonce (see PaymentProcessor_Simplypay::
     * _injectCspNonce()) is silently dropped and the script gets blocked under csp_strict_inline,
     * even though the fetched HTML had the correct nonce.
     *
     * This fetches the URL itself and inserts the response using plain DOM APIs only - never
     * jQuery's .html()/.append(), which would re-trigger the same script handling on the
     * reconstructed elements - so nonce/src survive on the element that actually executes.
     * Drop-in replacement for $container.load(url, callback).
     *
     * @param {jQuery} $container
     * @param {string} url
     * @param {function} [callback]
     */
    return function loadWithNonce($container, url, callback) {
        $.get(url).done(function (html) {
            var container = $container[0];

            // Native innerHTML parsing leaves <script> tags inert and intact (attributes
            // included) - unlike jQuery's .html(), which strips/re-fetches them immediately.
            var wrapper = document.createElement('div');
            wrapper.innerHTML = html;

            var oldScripts = wrapper.querySelectorAll('script');
            for (var i = 0; i < oldScripts.length; i++) {
                var oldScript = oldScripts[i];
                var newScript = document.createElement('script');

                for (var j = 0; j < oldScript.attributes.length; j++) {
                    var attr = oldScript.attributes[j];
                    newScript.setAttribute(attr.name, attr.value);
                }
                newScript.text = oldScript.textContent;

                oldScript.parentNode.replaceChild(newScript, oldScript);
            }

            container.innerHTML = '';
            while (wrapper.firstChild) {
                container.appendChild(wrapper.firstChild);
            }

            if (callback) {
                callback();
            }
        });
    };

});

